module.exports = __webpack_public_path__ + "static/media/integrations.81afaf7d.png";